import TextModalHeading from "../UI/Typography/TextModalHeading";
import Button from "../UI/Button/Button";
import Modal from "../UI/Modal/Modal";
import {IModalProps} from "./types";
import TextSubheading from '../UI/Typography/TextSubheading';
import TextRegularGrey from "../UI/Typography/TextRegularGrey";
import { useTranslation } from 'react-i18next';

const ModalZylindertypen = ({ onClose }: IModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      onClose={onClose}
      maxWidth='720px'
      width='100%'
    >
      <TextModalHeading sx={{ marginBottom: '32px' }}>
        {t('modal.zylinder-types.title')}
      </TextModalHeading>

      <TextSubheading sx={{ marginBottom: '8px' }}>
        {t('modal.zylinder-types.double-cylinder.title')}
      </TextSubheading>
      <TextRegularGrey sx={{ marginBottom: '32px' }}>
        {t('modal.zylinder-types.double-cylinder.text')}
      </TextRegularGrey>

      <TextSubheading sx={{ marginBottom: '8px' }}>
        {t('modal.zylinder-types.half-cylinder.title')}
      </TextSubheading>
      <TextRegularGrey sx={{ marginBottom: '32px' }}>
        {t('modal.zylinder-types.half-cylinder.text')}
      </TextRegularGrey>

      <TextSubheading sx={{ marginBottom: '8px' }}>
        {t('modal.zylinder-types.knob-cylinder.title')}
      </TextSubheading>
      <TextRegularGrey sx={{ marginBottom: '32px' }}>
        {t('modal.zylinder-types.knob-cylinder.text')}
      </TextRegularGrey>

      <TextSubheading sx={{ marginBottom: '8px' }}>
        {t('modal.zylinder-types.emergency.title')}
      </TextSubheading>
      <TextRegularGrey sx={{ marginBottom: '32px' }}>
        {t('modal.zylinder-types.emergency.text')}
        <br></br>
        {t('modal.zylinder-types.emergency.subtext')}
      </TextRegularGrey>

      <TextSubheading sx={{ marginBottom: '8px' }}>
        {t('modal.zylinder-types.freewheel.title')}
      </TextSubheading>
      <TextRegularGrey sx={{ marginBottom: '32px' }}>
        {t('modal.zylinder-types.freewheel.text')}
        <br></br>
        {t('modal.zylinder-types.freewheel.subtext')}
      </TextRegularGrey>

      <TextSubheading sx={{ marginBottom: '8px' }}>
        {t('modal.zylinder-types.lever-cylinder.title')}
      </TextSubheading>
      <TextRegularGrey sx={{ marginBottom: '32px' }}>
        {t('modal.zylinder-types.lever-cylinder.text')}
      </TextRegularGrey>

      <TextSubheading sx={{ marginBottom: '8px' }}>
        {t('modal.zylinder-types.external-cylinder.title')}
      </TextSubheading>
      <TextRegularGrey sx={{ marginBottom: '32px' }}>
        {t('modal.zylinder-types.external-cylinder.text')}
      </TextRegularGrey>

      <TextSubheading sx={{ marginBottom: '8px' }}>
        {t('modal.zylinder-types.padlock.title')}
      </TextSubheading>
      <TextRegularGrey>
        {t('modal.zylinder-types.padlock.text')}
      </TextRegularGrey>

      <Button
        variant='second'
        sx={{
          marginTop: '32px',
        }}
        onClick={onClose}
      >
        {t('modal.close')}
      </Button>
    </Modal>
  );
};

export default ModalZylindertypen;
